import { inject } from 'vue'
import { usePasskeyVerify } from '@laravel/passkeys/vue'

const routes = {
  options: `${import.meta.env.API_HOST_URL}/login/passkey/options`,
  submit: `${import.meta.env.API_HOST_URL}/login/passkey`
}

export const usePasskeyLogin = ({ onSuccess, onError } = {}) => {
  const $axios = inject('$axios')
  const { verify: verifyPasskey, isLoading, isSupported, error } = usePasskeyVerify({ routes, onSuccess, onError })

  const verify = async () => {
    // The session-based POST /login/passkey needs the XSRF cookie in place
    // first, exactly like the password login flow (see AuthStore.login) —
    // this client calls fetch() directly, not our $axios instance, so it
    // never goes through axios's withXSRFToken handling.
    await $axios.get('/sanctum/csrf-cookie')
    return verifyPasskey()
  }

  return { verify, isLoading, isSupported, error }
}
